/* ════════════════════════════════════════════════════════════════
   DEZE PLANT IN JOUW TUIN — modulegedrag
   Verbindt het paspoort ("Zo groeit hij"), de plantwijzer ("Plan
   jouw tuin") en de koopzone tot één verhaal:
   · uitklappers met samenvatting in gesloten staat (360/240 ms);
   · de kernkenmerken in "In één oogopslag" openen het juiste
     hoofdstuk en lichten het bijbehorende deel van de tekening op;
   · "Gebruik N als aantal" zet het advies in het aantalveld —
     de winkelwagen wordt níet automatisch geopend;
   · de mobiele koopbalk krijgt een adviesstrip (één balk, geen
     concurrerende resultaatbalk);
   · luistert naar de bestaande imenhof:plantwijzer-events.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var pijt = document.querySelector('[data-pijt]');
  if (!pijt) return;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DESKTOP = window.matchMedia('(min-width: 901px)');
  var money = function (cents) {
    return window.Shopify && Shopify.formatMoney
      ? Shopify.formatMoney(cents, window.themeMoneyFormat)
      : '€' + (cents / 100).toFixed(2).replace('.', ',');
  };

  /* ── uitklappers ── */
  var blokken = {};
  pijt.querySelectorAll('[data-pijt-blok]').forEach(function (blok) {
    var naam = blok.dataset.pijtBlok;
    var knop = blok.querySelector('[data-pijt-knop]');
    var paneel = blok.querySelector('.pijt__paneel');
    if (!knop || !paneel) return;
    blokken[naam] = { blok: blok, knop: knop, paneel: paneel };
    knop.addEventListener('click', function () {
      zet(naam, !blok.classList.contains('is-open'));
    });
  });
  function zet(naam, open) {
    var b = blokken[naam];
    if (!b) return;
    b.blok.classList.toggle('is-open', open);
    b.knop.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function openBlok(naam, scrollErheen) {
    var b = blokken[naam];
    if (!b || b.blok.hidden) return;
    zet(naam, true);
    if (scrollErheen) {
      window.setTimeout(function () {
        b.knop.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
      }, REDUCED ? 0 : 120);
    }
  }
  /* beginstand: "Zo groeit hij" open op desktop, alles dicht op mobiel */
  zet('groei', DESKTOP.matches);
  zet('plan', false);

  /* ── samenvatting "Zo groeit hij" (uit het paspoort-data-eiland) ── */
  (function () {
    var dataEl = pijt.querySelector('[data-ihkp-data]');
    var sam = pijt.querySelector('[data-pijt-sam="groei"]');
    if (!dataEl || !sam) return;
    try {
      var d = JSON.parse(dataEl.textContent);
      var stukken = [];
      if (d.spLabel) stukken.push(d.spLabel);
      if (d.hoogte) stukken.push(d.hoogte);
      if (d.bloeiseizoen && d.bloeiseizoen.length) {
        stukken.push('bloeit in ' + d.bloeiseizoen.join(' & ').toLowerCase());
      } else if (d.winterhard === true) {
        stukken.push('winterhard');
      }
      sam.textContent = stukken.join(' · ');
    } catch (e) { /* samenvatting is optioneel */ }
  })();

  /* ── plantwijzer-koppeling ── */
  var pw = document.getElementById('plantwijzer');
  var planSam = pijt.querySelector('[data-pijt-sam="plan"]');
  var gebruikWrap = document.getElementById('pw-gebruik');
  var gebruikKnop = document.getElementById('pw-gebruikKnop');
  var gebruikAantal = document.getElementById('pw-gebruikAantal');
  var gebruikTotaal = document.getElementById('pw-gebruikTotaal');
  var gebruikOk = document.getElementById('pw-gebruikOk');
  var confirmEl = document.querySelector('[data-tuin-confirm]');
  var buybarAdvies = document.querySelector('[data-buybar-advies]');
  var buybarAdviesTekst = buybarAdvies && buybarAdvies.querySelector('[data-buybar-advies-tekst]');
  var buybarAdviesUse = buybarAdvies && buybarAdvies.querySelector('[data-buybar-advies-use]');
  var productSection = document.querySelector('[data-product-section]');
  var qtyInput = document.querySelector('[data-product-form] [name="quantity"]');

  var advies = { geldig: false, aantal: null, label: '', aangeraakt: false };
  var gebruikt = null;      /* laatst toegepaste aantal */
  var planZichtbaar = true;
  var buybarOkTimer = null;

  function mv(n) { return n === 1 ? 'plant' : 'planten'; }

  function huidigePrijsCents() {
    var idInput = document.querySelector('[data-product-form] [name="id"]');
    var vj = document.querySelector('[data-variants-json]');
    if (idInput && vj) {
      try {
        var data = JSON.parse(vj.textContent);
        for (var i = 0; i < data.length; i++) {
          if (String(data[i].id) === String(idInput.value)) return data[i].price;
        }
      } catch (e) { /* val terug op sectie-attribuut */ }
    }
    var p = productSection ? parseInt(productSection.dataset.currentPriceCents || '', 10) : NaN;
    return Number.isFinite(p) ? p : null;
  }

  function zetPlanSam() {
    if (!planSam) return;
    if (advies.geldig && advies.aantal && advies.aangeraakt) {
      planSam.textContent = 'Jouw advies — ' + advies.aantal + ' ' + mv(advies.aantal);
    } else if (pw && pw.dataset.pootafstandCm) {
      planSam.textContent = 'Aanbevolen plantafstand ' + pw.dataset.pootafstandCm + ' cm';
    }
  }

  function vernieuwGebruik() {
    if (!gebruikWrap) return;
    var toon = planZichtbaar && advies.geldig && !!advies.aantal;
    gebruikWrap.hidden = !toon;
    if (!toon) return;
    if (gebruikAantal) gebruikAantal.textContent = advies.aantal;
    var prijs = huidigePrijsCents();
    if (gebruikTotaal) {
      if (prijs !== null) {
        gebruikTotaal.textContent = advies.aantal + ' ' + mv(advies.aantal) + ' · totaal ' + money(prijs * advies.aantal);
        gebruikTotaal.hidden = false;
      } else {
        gebruikTotaal.hidden = true;
      }
    }
    if (gebruikOk && gebruikt !== advies.aantal) gebruikOk.hidden = true;
  }

  function vernieuwBuybar() {
    if (!buybarAdvies) return;
    var toon = planZichtbaar && advies.geldig && !!advies.aantal && advies.aangeraakt && gebruikt !== advies.aantal;
    if (buybarOkTimer) return; /* korte ✓-status niet onderbreken */
    buybarAdvies.hidden = !toon;
    buybarAdvies.classList.remove('is-ok');
    if (toon && buybarAdviesTekst) {
      buybarAdviesTekst.textContent = 'Advies voor ' + (advies.label || 'jouw tuinvak') + ': ' + advies.aantal + ' ' + mv(advies.aantal);
    }
    window.dispatchEvent(new Event('resize')); /* laat product.js de balkhoogte opnieuw meten */
  }

  function verbergBevestigingen() {
    if (confirmEl) confirmEl.hidden = true;
    if (gebruikOk) gebruikOk.hidden = true;
  }

  /* blaadje dat naar het aantalveld vliegt (klein, eenmalig, respecteert reduced motion) */
  function blaadjeNaarAantal() {
    if (REDUCED || !qtyInput || !gebruikKnop || typeof gebruikKnop.animate !== 'function') return;
    var naar = qtyInput.getBoundingClientRect();
    if (!naar.width || naar.bottom < 0 || naar.top > window.innerHeight) return;
    var van = gebruikKnop.getBoundingClientRect();
    var blad = document.createElement('div');
    blad.className = 'pijt-blad';
    blad.setAttribute('aria-hidden', 'true');
    blad.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19C5 10 11 5 20 4c-.5 9-5 15-15 15Z"/><path d="M7 17C10 13 13 10 17 7"/></svg>';
    document.body.appendChild(blad);
    var x0 = van.left + van.width / 2, y0 = van.top + van.height / 2;
    var dx = naar.left + naar.width / 2 - x0, dy = naar.top + naar.height / 2 - y0;
    blad.style.left = x0 + 'px';
    blad.style.top = y0 + 'px';
    var anim = blad.animate([
      { transform: 'translate(-50%,-50%) rotate(0deg) scale(1)', opacity: 1 },
      { transform: 'translate(calc(-50% + ' + dx * 0.5 + 'px), calc(-50% + ' + (dy * 0.5 - 46) + 'px)) rotate(140deg) scale(1.08)', opacity: 1, offset: 0.6 },
      { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) rotate(230deg) scale(.45)', opacity: 0 }
    ], { duration: 700, easing: 'cubic-bezier(.3,.7,.3,1)' });
    anim.onfinish = function () {
      blad.remove();
      qtyInput.classList.add('pijt-puls');
      window.setTimeout(function () { qtyInput.classList.remove('pijt-puls'); }, 520);
    };
  }

  function pasToe(bron) {
    if (!advies.geldig || !advies.aantal || !qtyInput) return;
    qtyInput.value = String(advies.aantal);
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    gebruikt = advies.aantal;
    window.dispatchEvent(new CustomEvent('imenhof:plantwijzer-used', { detail: { quantity: advies.aantal } }));
    var tekst = '✓ ' + advies.aantal + ' ' + mv(advies.aantal) + ' gekozen' + (advies.label ? ' voor ' + advies.label : '');
    if (gebruikOk) { gebruikOk.textContent = tekst; gebruikOk.hidden = false; }
    if (confirmEl) { confirmEl.textContent = tekst; confirmEl.hidden = false; }
    if (bron === 'buybar' && buybarAdvies && buybarAdviesTekst) {
      buybarAdvies.classList.add('is-ok');
      buybarAdviesTekst.textContent = tekst;
      if (buybarOkTimer) window.clearTimeout(buybarOkTimer);
      buybarOkTimer = window.setTimeout(function () {
        buybarOkTimer = null;
        vernieuwBuybar();
      }, 2600);
    } else {
      vernieuwBuybar();
    }
    if (bron === 'paneel') blaadjeNaarAantal();
  }

  if (gebruikKnop) gebruikKnop.addEventListener('click', function () { pasToe('paneel'); });
  if (buybarAdviesUse) buybarAdviesUse.addEventListener('click', function () { pasToe('buybar'); });

  function zetPlanZichtbaar(z) {
    planZichtbaar = z;
    if (blokken.plan) blokken.plan.blok.hidden = !z;
    document.querySelectorAll('[data-pijt-open="plan"]').forEach(function (k) {
      var item = k.closest('.plant-guide__item');
      (item || k).hidden = !z;
    });
    vernieuwGebruik();
    vernieuwBuybar();
  }

  window.addEventListener('imenhof:plantwijzer-update', function (e) {
    var d = e.detail || {};
    advies.geldig = !!d.valid;
    if (d.valid) {
      if (gebruikt !== null && d.quantity !== gebruikt) verbergBevestigingen();
      advies.aantal = d.quantity;
      advies.label = d.label || advies.label;
      advies.aangeraakt = !!d.aangeraakt || advies.aangeraakt;
    }
    vernieuwGebruik();
    zetPlanSam();
    vernieuwBuybar();
  });
  window.addEventListener('imenhof:plantwijzer-availability', function (e) {
    zetPlanZichtbaar(!!(e.detail && e.detail.available));
  });

  /* beginstand uit het DOM (plantwijzer.js draaide al vóór dit script) */
  if (!pw) {
    zetPlanZichtbaar(false);
  } else {
    if (pw.style.display === 'none') zetPlanZichtbaar(false);
    advies.aantal = parseInt(pw.dataset.adviesAantal || '', 10) || null;
    advies.geldig = pw.dataset.adviesGeldig === 'true' && !!advies.aantal;
    advies.label = pw.dataset.adviesLabel || '';
    advies.aangeraakt = pw.dataset.adviesAangeraakt === 'true';
    vernieuwGebruik();
    zetPlanSam();
    vernieuwBuybar();
  }

  /* prijs in "totaal €…" volgt de gekozen variant */
  document.addEventListener('change', function (ev) {
    if (!ev.target || !ev.target.closest || !ev.target.closest('[data-variant-picker]')) return;
    window.requestAnimationFrame(function () { vernieuwGebruik(); });
  });

  /* ── kernkenmerken als ingang ── */
  if (blokken.groei) {
    document.querySelectorAll('[data-pijt-target]').forEach(function (item) {
      item.classList.add('is-koppelbaar');
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      var doel = item.dataset.pijtTarget;
      function ga() {
        openBlok('groei', true);
        var stat = pijt.querySelector('.ihkp__stat[data-hl="' + doel + '"]');
        if (!stat) return;
        window.setTimeout(function () {
          stat.dispatchEvent(new Event('mouseenter'));
          window.setTimeout(function () { stat.dispatchEvent(new Event('mouseleave')); }, 2400);
        }, REDUCED ? 0 : 420);
      }
      item.addEventListener('click', ga);
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ga(); }
      });
    });
  }
  document.querySelectorAll('[data-pijt-open]').forEach(function (k) {
    k.addEventListener('click', function () { openBlok(k.dataset.pijtOpen, true); });
  });
})();
